import React from 'react'
import SystemReports from '../components/admin/SystemReports'

const AdminReports: React.FC = () => {
  return <SystemReports />
}

export default AdminReports